import { render } from "./TheSpeedometer.vue?vue&type=template&id=6227a527&scoped=true&scoped=true"
import script from "./TheSpeedometer.vue?vue&type=script&scoped=true&lang=js"
export * from "./TheSpeedometer.vue?vue&type=script&scoped=true&lang=js"

import "./TheSpeedometer.vue?vue&type=style&index=0&id=6227a527&scoped=true&lang=css"

import exportComponent from "/home/guilh/Milhagem/Telemetria/dt2-telemetria-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6227a527"]])

export default __exports__